import T from 'prop-types';
import React, { useState } from 'react';

import { be, bm } from '@skippay/core/utils/classUtils';

import './index.sass';

const MODULE_NAME = 'Image';

function Image(props) {
	const {
		alt,
		animated,
		auto,
		border,
		borderRadius,
		caption,
		centered,
		full,
		hasSensitiveContent,
		gatsby,
		large,
		logo,
		mobileLogo,
		noResize,
		placeholder,
		printMedium,
		printSmall,
		spacing,
		src,
		tall,
		thumbnail,
		transparent,
		wide,
		loading,
		maxWidth,
		className,
		waitTillLoaded,
		loader,
		...restProps
	} = props;

	const [isLoaded, setIsLoaded] = useState(false);

	return (
		<div
			className={
				className ??
				bm(MODULE_NAME, {
					auto,
					borderRadius,
					caption,
					centered,
					full,
					spacing,
					border,
					wide,
					large,
					tall,
					logo,
					mobileLogo,
					noResize,
					printSmall,
					printMedium,
					placeholder,
					thumbnail,
					transparent,
					animated,
					gatsby,
				})
			}
			style={{ maxWidth }}
		>
			{caption && <div className={be(MODULE_NAME, 'caption')}>{caption}</div>}
			{gatsby ? (
				<span className={be(MODULE_NAME, 'image')}>{gatsby}</span>
			) : (
				<>
					{waitTillLoaded && !isLoaded && loader}
					<img
						loading={loading}
						className={be(MODULE_NAME, 'image', { hidden: waitTillLoaded && !isLoaded })}
						src={src}
						alt={alt}
						{...(hasSensitiveContent && { 'data-clarity-mask': true })}
						{...restProps}
						{...(waitTillLoaded && {
							onLoad: () => setIsLoaded(true),
							onError: () => setIsLoaded(false),
						})}
					/>
				</>
			)}
		</div>
	);
}

Image.propTypes = {
	alt: T.string,
	animated: T.bool,
	auto: T.bool,
	border: T.bool,
	borderRadius: T.bool,
	caption: T.node,
	centered: T.bool,
	full: T.bool,
	hasSensitiveContent: T.bool,
	/**
	 * React element of gatsby-image, allows use API of Image with gatsby-image.
	 */
	gatsby: T.element,
	large: T.bool,
	logo: T.bool,
	mobileLogo: T.bool,
	noResize: T.bool,
	placeholder: T.bool,
	printMedium: T.bool,
	printSmall: T.bool,
	spacing: T.bool,
	src: T.any,
	tall: T.bool,
	thumbnail: T.bool,
	transparent: T.bool,
	wide: T.bool,
	loading: T.oneOf(['lazy', 'eager']),
	maxWidth: T.number,
	width: T.string,
	height: T.string,
	onClick: T.func,
	className: T.string,
	waitTillLoaded: T.bool,
	loader: T.element,
};

export default Image;
